<template>
  <v-container class="my-5">
    <v-row>
      <v-col cols="12" md="12">
        <v-btn
          text
          class="text-capitalize mr-1 hover-class-style"
          active-class="active-class-style"
          :to="{ name: 'ListclassDosen' }">
          <v-icon left>mdi-archive-check</v-icon> Kelas Aktif
        </v-btn>
        <v-btn
          text
          class="text-capitalize mr-1 hover-class-style"
          active-class="active-class-style"
          :to="{ name: 'ArchiveclassDosen' }">
          <v-icon left>mdi-archive</v-icon> Kelas Arsip
        </v-btn>
        <v-btn
          text
          class="text-capitalize mr-1 hover-class-style"
          active-class="active-class-style"
          :to="{ name: 'OtherAbsence' }"
          exact>
          <v-icon left>mdi-receipt-text-clock-outline</v-icon> Presensi Lainnya
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <v-card flat>
          <v-card-text>
            <v-row justify="center" class="black--text">
              <v-col cols="12" md="5">
                <div class="mb-12">
                  <h6 class="text-h6">Form Presensi Lainnya</h6>
                  <v-divider class="my-1"></v-divider>
                </div>
                <div class="mb-3">
                  <v-form
                    @submit.prevent="submitOpenJadwal"
                    ref="formregclass"
                    v-model="formadd.jobclass"
                    lazy-validation>
                    <v-row justify="center">
                      <v-col cols="12" md="5">
                        <v-autocomplete
                          dense
                          v-model="regclass.type_abslain"
                          :rules="[rules.required]"
                          :items="type_abslain"
                          label="Jenis Presensi *"
                          name="typepresensi">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="7">
                        <v-text-field
                          dense
                          v-model="regclass.nofile_abslain"
                          :rules="[rules.required]"
                          label="Nomor Surat *"
                          name="nofile_abslain"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-file-input
                          v-model="regclass.file_abslain"
                          :rules="rules.files"
                          accept=".pdf"
                          name="file_abslain"
                          placeholder="Select file"
                          label="Upload Bukti *"
                          show-size>
                        </v-file-input>
                      </v-col>
                      <v-col cols="12" md="12" v-if="false">
                        <v-textarea
                          name="note_abslain"
                          label="Catatan"
                          placeholder="Presensi lainnya"
                          rows="3"
                          v-model="regclass.note_abslain">
                        </v-textarea>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-autocomplete
                          v-model="pilihjadwal"
                          :items="listjadwal"
                          label="Jadwal Kelas *"
                          return-object
                          :rules="[rules.required]"
                          @change="pilihanJadwal(pilihjadwal)">
                          <template v-slot:selection="data">
                            <v-chip small label class="chip-h-auto">
                              <div>
                                <strong>{{ data.item.mataKuliah }} - {{ data.item.semester + '' + data.item.kelas }}</strong>
                                ( {{ data.item.jadwal_Hari | intToDate }}, {{ data.item.jadwal_Start }} - {{ data.item.jadwal_Selesai }} )
                              </div>
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>{{ item.mataKuliah }} - {{ item.semester + '' + item.kelas }}</v-list-item-title>
                              <v-list-item-subtitle>{{ item.jadwal_Hari | intToDate }}, {{ item.jadwal_Start }} - {{ item.jadwal_Selesai }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon>mdi-coin</v-icon>
                            </v-list-item-action>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-text-field
                          dense
                          v-model="regclass.materi_abslain"
                          :rules="[rules.required]"
                          label="Pokok Bahasan *"
                          name="materi_abslain"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="12">
                        <p>
                          * wajib diisi
                        </p>
                        <alertsp :alertdata="alertreg"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.reg"
                          :disabled="loading.reg || !formadd.jobclass"
                          :color="maincolor"
                          class="mr-4 mt-3 white--text text-capitalize"
                          type="submit">
                          Simpan
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
              </v-col>
              <v-col cols="12" md="7">
                <div class="mb-8">
                  <h6 class="text-h6">Presensi yang sedang berjalan</h6>
                  <v-divider class="my-1"></v-divider>
                </div>
                <div class="mb-3">
                  <v-col cols="12" md="12" v-if="loading.jadwal" class="text-center">
                    <v-progress-circular
                      :width="3"
                      color="red"
                      indeterminate>
                    </v-progress-circular>
                  </v-col>
                  <v-data-table
                    v-if="!loading.jadwal && listabsensi"
                    :headers="headers"
                    :items="listabsensi"
                    :search="filter.search">
                    <template v-slot:[`item.kelas`]="{ item }">
                      <span>{{ item.semester + '' + item.kelas }}</span>
                    </template>
                    <template v-slot:[`item.harikuliah`]="{ item }">
                      {{ item.jadwal_Hari | intToDate }},<br/>
                      ({{ item.tanggal }})
                    </template>
                    <template v-slot:[`item.jamkuliah`]="{ item }">
                      <span>{{ item.jadwal_Start_Seharusnya + ' - ' + item.jadwal_Selesai_Seharusnya }}</span>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        color="error"
                        title="Tutup Presensi"
                        @click="confirmClose(item)"
                        small
                        icon>
                        <v-icon>mdi-stop-circle</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="12">
        <div class="text-center">
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'ListclassDosen' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Daftar kelas</span>
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dmodal.closeabsen"
      max-width="450px">
      <v-card v-if="dmodaldata.closeabsen">
        <v-card-title>
          <span>Tutup absensi berikut</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.closeabsen = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <div class="font-weight-bold">
            {{ dmodaldata.closeabsen.mataKuliah }} ({{ dmodaldata.closeabsen.semester + '' + dmodaldata.closeabsen.kelas }})
          </div>
          <div>
            Materi: {{ dmodaldata.closeabsen.pokokBahasan }}
          </div>
          <div>
            Tanggal: {{ dmodaldata.closeabsen.tanggal }}
          </div>
          <div>
            Mulai: {{ dmodaldata.closeabsen.jamMulai }}
          </div>
          <alertsp class="mt-5 mb-1" :alertdata="alertclose"></alertsp>
          <v-btn
            class="mt-5"
            depressed
            tile
            small
            color="error"
            :loading="loading.close"
            :disabled="loading.close"
            @click="closeAbsensi(dmodaldata.closeabsen)">
            Tutup
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'OtherAbsence',
  data: () => ({
    alertclose: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertreg: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      reg: false,
      regcom: false,
      getdata: false,
      close: false,
      jadwal: false,
    },
    publickey: '123',
    api: process.env.VUE_APP_API,
    apision: process.env.VUE_APP_APISION,
    baseurl: process.env.VUE_APP_BASEURL,
    hash: process.env.VUE_APP_HASH,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    type_abslain: ['Penelitian', 'Pengabdian', 'Tugas', 'Sakit', 'Lainnya'],
    listabsensi: [],
    listjadwal: [],
    pilihjadwal: null,
    liststatus: ['active', 'passive'],
    listtahunajaran: ['2021-2022', '2022-2023'],
    listtahunangkatan: ['2016', '2017', '2018', '2019', '2020', '2021', '2022'],
    listclsangkatan: [],
    listsemester: [1, 2, 3, 4, 5, 6, 7, 8],
    listprodi: [],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Matkul', value: 'mataKuliah' },
      { text: 'Kelas', value: 'kelas' },
      { text: 'Hari', value: 'harikuliah' },
      { text: 'Jam', value: 'jamkuliah' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    regclass: {
      kelasid_abslain: '',
      type_abslain: 'Penelitian',
      nofile_abslain: '',
      file_abslain: null,
      note_abslain: 'Presensi lainnya',
      materi_abslain: '',
      jadwal_hari: '',
    },
    regcompany: {
      firstname: '',
      lastname: '',
      email: '',
      companyname: '',
      companyphone: '',
      password: '',
    },
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      jobclass: false,
      company: false,
      passwordjs: false,
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
      files: [
        (value) => !value || value.size < 5000000 || 'Files less than 5 MB!',
      ],
    },
    tabdata: null,
    dmodal: {
      closeabsen: false,
    },
    dmodaldata: {
      closeabsen: null,
    },
    tahunaktif: process.env.VUE_APP_TH,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userno',
    ]),
  },
  mounted() {
    this.getJadwal();
    this.getAbsensi();
    // const hashactv = sha256('20222199004042019031017' + this.hash);
    // console.log(this.userno);
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    intToDate(value) {
      const arrday = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
      let retday = arrday[1];
      if (value >= 0 && value < 7) {
        retday = arrday[value];
      }
      return retday;
    },
  },
  methods: {
    confirmClose(item) {
      this.alertclose.show = false;
      this.dmodal.closeabsen = true;
      this.dmodaldata.closeabsen = JSON.parse(JSON.stringify(item));
    },
    pilihanJadwal(jdw) {
      // console.log(jdw);
      this.regclass.kelasid_abslain = jdw.kelas_ID;
      this.regclass.jadwal_hari = jdw.jadwal_Hari;
    },
    closeAbsensi(item) {
      this.alertclose.show = false;
      if (item.kpa_id) {
        this.loading.close = true;
        const strhex = item.kpa_id + '' + item.jadwal_Hari + '' + this.hash;
        const hashactv = sha256(strhex);
        const senddata = {
          Kpa_ID: item.kpa_id,
          jadwal_Hari: item.jadwal_Hari,
          hashCode: hashactv.toUpperCase(),
        };
        this.axios
          .post(
            this.apision + '/TutupAbsensi',
            senddata,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.responseCode === '00') {
                this.dmodal.closeabsen = false;
                this.dmodaldata.closeabsen = null;
                this.getAbsensi();
              } else {
                this.alertclose.show = true;
                this.alertclose.type = 'error';
                this.alertclose.text = resdata.responseDescription;
              }
            } else {
              this.alertclose.show = true;
              this.alertclose.type = 'error';
              this.alertclose.text = 'Internal services error!';
            }
            this.loading.close = false;
          })
          .catch((error) => {
            this.alertclose.show = true;
            this.alertclose.type = 'error';
            this.alertclose.text = 'Internal services error!';
            this.loading.close = false;
          });
      } else {
        this.alertclose.show = true;
        this.alertclose.type = 'error';
        this.alertclose.text = 'Invalid data!';
      }
    },
    getJadwal() {
      this.listjadwal = [];
      const strhex = this.tahunaktif +
        '' + this.userno +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        TahunAkademik: this.tahunaktif,
        IDDosen: this.userno,
        hashCode: hashactv.toUpperCase(),
      };
      this.axios
      .post(
          this.apision + '/JadwalMengajarDosen',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.listjadwal = resdata.jadwal;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAbsensi() {
      this.loading.jadwal = true;
      this.listabsensi = [];
      const strhex = this.tahunaktif +
        '' + this.userno +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        TahunAkademik: this.tahunaktif,
        IDDosen: this.userno,
        hashCode: hashactv.toUpperCase(),
      };
      this.axios
      .post(
          this.apision + '/DaftarAbsensiBerjalan',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            if (resdata.responseCode === '00') {
              this.listabsensi = resdata.jadwal;
            }
          }
          this.loading.jadwal = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading.jadwal = false;
        });
    },
    submitOpenJadwal() {
      this.alertreg.show = false;
      if (this.$refs.formregclass.validate()) {
        if (this.tokenscr) {
          // console.log(this.regclass);
          this.loading.reg = true;
          const strhex = this.regclass.kelasid_abslain +
            '' + this.regclass.materi_abslain +
            '' + this.regclass.note_abslain +
            '' + this.userno +
            '' + this.regclass.jadwal_hari +
            '' + this.hash;
          const hashactv = sha256(strhex);
          const senddata = {
            Kelas_ID: this.regclass.kelasid_abslain,
            PokokBahasan: this.regclass.materi_abslain,
            Catatan: this.regclass.note_abslain,
            NIP: this.userno,
            JadwalHari: this.regclass.jadwal_hari,
            hashCode: hashactv.toUpperCase(),
          };
          // console.log(senddata);
          // this.insertAbsen('2370/KPM/072023');
          this.axios
            .post(
              this.apision + '/BukaAbsensi',
              senddata,
              {
                headers: {
                  'Content-Type': 'application/json',
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.responseCode === '00') {
                  // call insert data local
                  this.insertAbsen(resdata.kpa_id);
                  // update absen
                  this.getAbsensi();
                } else {
                  this.alertreg.show = true;
                  this.alertreg.type = 'error';
                  this.alertreg.text = resdata.responseDescription;
                }
              } else {
                this.alertreg.show = true;
                this.alertreg.type = 'error';
                this.alertreg.text = 'Internal services error 1!';
              }
              this.loading.reg = false;
            })
            .catch((error) => {
              console.log(error);
              this.alertreg.show = true;
              this.alertreg.type = 'error';
              this.alertreg.text = 'Internal services error 2!';
              this.loading.reg = false;
            });
        } else {
          this.alertreg.show = true;
          this.alertreg.type = 'error';
          this.alertreg.text = 'Invalid token!';
        }
      }
    },
    insertAbsen(kpaid) {
      // console.log(this.regclass);
      // console.log(this.pilihjadwal);
      // this.$refs.formregclass.reset();
      if (this.tokenscr) {
        this.loading.reg = true;
        const datapilih = this.pilihjadwal;
        const dataadd = this.regclass;
        const formData = new FormData();
        // file image
        formData.append('file_abslain', dataadd.file_abslain);
        formData.append('type_abslain', dataadd.type_abslain);
        formData.append('nofile_abslain', dataadd.nofile_abslain);
        formData.append('note_abslain', dataadd.note_abslain);
        formData.append('kelasid_abslain', datapilih.kelas_ID);
        formData.append('start_abslain', datapilih.jadwal_Start);
        formData.append('end_abslain', datapilih.jadwal_Selesai);
        formData.append('tgl_abslain', datapilih.jadwal_Selanjutnya);
        formData.append('mk_abslain', datapilih.mataKuliah);
        formData.append('kelas_abslain', datapilih.semester + '' + datapilih.kelas);
        formData.append('materi_abslain', dataadd.materi_abslain);
        formData.append('status_abslain', 'open');
        formData.append('kpaid_abslain', kpaid);
        formData.append('userno_absen', this.userno);
        // send data
        this.axios
          .post(
            this.api + '/api/pertemuan/absenlain',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.alertreg.show = true;
                this.alertreg.type = 'success';
                this.alertreg.text = 'Presensi kelas "' + datapilih.mataKuliah + '" berhasil dibuka!';
                this.$refs.formregclass.reset();
              } else {
                this.alertreg.show = true;
                this.alertreg.type = 'error';
                this.alertreg.text = resdata.message;
              }
            } else {
              this.alertreg.show = true;
              this.alertreg.type = 'error';
              this.alertreg.text = 'Internal services error!';
            }
            this.loading.reg = false;
          })
          .catch((error) => {
            this.loading.reg = false;
            this.alertreg.show = true;
            this.alertreg.type = 'error';
            this.alertreg.text = 'Internal services error!';
          });
      } else {
        this.alertreg.show = true;
        this.alertreg.type = 'error';
        this.alertreg.text = 'Invalid token!';
      }
    },
    closeDmodal(type) {
      if (type === 'closeabsen') {
        this.dmodal.closeabsen = false;
      } else {
        this.dmodal.closeabsen = false;
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
